import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useLocation } from 'react-router-dom';  // useLocation import edildi

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();  // Sayfa değişikliklerini izlemek için

  // Butonun görünürlüğünü ayarlamak için scroll event handler
  const toggleVisibility = () => {
    if (window.pageYOffset > 100) { // Sayfa 100px aşağı kaydırıldığında buton görünsün
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  // Sayfayı en üste kaydırmak için fonksiyon
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Sayfa değiştiğinde sayfayı en üste kaydır
  useEffect(() => {
    window.scrollTo(0, 0);  // Sayfa değiştiğinde her zaman en üste kaydır
  }, [location]);  // location değiştiğinde trigger olur

  // Scroll event'ini dinliyoruz
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility); // Temizlik
  }, []);

  return (
    <IconButton
      onClick={scrollToTop}
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        backgroundColor: 'orange',  // Turuncu renk
        color: 'white',
        padding: '15px',  // Butonun büyüklüğü
        borderRadius: '5px',  // Kare şekil için
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        cursor: 'pointer',
        fontSize: '18px',
        zIndex: 1000,
        display: visible ? 'inline-flex' : 'none', // Butonun sadece görünür olması için
      }}
    >
      <ArrowUpwardIcon />
    </IconButton>
  );
};

export default ScrollToTopButton;
